

function reprExtendFromView (viewName, addDefaultRepr) {
	function repr () {
		return this.view(viewName);
	}

	const extend = {
		repr: {
			[viewName]: repr,
		},
	};

	if (addDefaultRepr) {
		extend.repr.default = repr;
	}

	return extend;
}

module.exports = {
	reprExtendFromView,
};
